import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";

import img1 from "../img/10276.jpg";
import img2 from "../img/16268343_rm373batch5-blogbanner-02.jpg";
import img3 from "../img/16522.jpg";
import img4 from "../img/2150010142.jpg";
import img5 from "../img/2807766_18141.jpg";
import img6 from "../img/2807811_18186.jpg";
import img7 from "../img/4102312_876.jpg";
import img8 from "../img/413301251_33f2bcc4-5c3f-4b65-b2d5-2de27e022b74.jpg";
import img9 from "../img/422.jpg";
import img10 from "../img/6198115_2176.jpg";
import img11 from "../img/8800992_855.jpg";
import img12 from "../img/95296.jpg";
import img13 from "../img/group-young-teens-celebrating-world-youth-day-by-doing-activities-together.jpg";
import img14 from "../img/programming-background-with-person-working-with-codes-computer.jpg";

import "./HomeSlider.css"; // import CSS file

const images = [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13,
  img14,
];

export default function HomeSlider() {
  const [current, setCurrent] = useState(0);

  const prevSlide = () => {
    setCurrent((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrent((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(interval);
  }, [current]);

  return (
    <div className="slider-container1">
      <AnimatePresence mode="wait">
        <motion.img
          key={current}
          src={images[current]}
          alt={`Slide ${current}`}
          className="slider-image"
          initial={{ opacity: 0, x: 80 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -80 }}
          transition={{ duration: 0.6 }}
        />
      </AnimatePresence>

      <button onClick={prevSlide} className="nav-button left">
        <ChevronLeft size={28} />
      </button>

      <button onClick={nextSlide} className="nav-button right">
        <ChevronRight size={28} />
      </button>

      <div className="dots">
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`dot ${current === index ? "active" : ""}`}
          />
        ))}
      </div>
    </div>
  );
}
